module.exports = __webpack_public_path__ + "media/music.8f642477.ogg";